import { SETTINGS_ROUTES } from '../constants'

export const getEndUserSettingsRoutes = (
  settingsRoutePart: keyof typeof SETTINGS_ROUTES,
  installationId = ':installationId',
  storageId = ':storageId'
): string => {
  return `/installation/${installationId}/${storageId}/properties/${SETTINGS_ROUTES[settingsRoutePart]}`
}

export const getEndUserSettingsWallboxDetailsRoutes = (installationId = ':installationId', storageId = ':storageId', evseId = ':evseId'): string => {
  return `/installation/${installationId}/${storageId}/properties/${SETTINGS_ROUTES.wallbox}/${evseId}`
}
